import React, { useContext } from 'react'
import { Grid } from '@material-ui/core'
import { components } from 'cng-web-lib'
import { A6ATranslationContext } from '../contexts/A6ATranslationContext'

const {
    form: { field: { CngCodeMasterAutocompleteField } },
    CngGridItem
} = components

function A6AMessageFunctionSection(props) {
    const { disabled, shouldHideMap, addPage } = props
    const { getTranslatedText } = useContext(A6ATranslationContext)


    return (
        <Grid item xs={12}>
            <CngGridItem xs={12} shouldHide={shouldHideMap.messageFunction}>
                <Grid container justify='center'>
                    <Grid item xs={12}>
                        <CngCodeMasterAutocompleteField
                            name='messageFunction'
                            label={getTranslatedText('A6A', 'messageFunction')}
                            disabled={disabled}
                            codeType={addPage ? 'MESSAGE_FUNCTION_ADD' : 'MESSAGE_FUNCTION'}
                            required
                        />
                    </Grid>
                </Grid>
            </CngGridItem>
        </Grid>
    )
}

export default A6AMessageFunctionSection